import { StateCreator } from 'zustand'
import { SharedSlice } from 'src/components/slice'
import { TimeclockSharedSlice } from '../slice'

interface PunchesByStaffState {}

export interface PunchesByStaffSlice extends PunchesByStaffState {
  /**
   * Resets PunchesByStaff Slice state
   */
  resetPunchesByStaffSlice: () => void
}

const initialState: PunchesByStaffState = {}

const createPunchesByStaffSlice: StateCreator<
  PunchesByStaffSlice & TimeclockSharedSlice & SharedSlice,
  [],
  [],
  PunchesByStaffSlice
> = (set) => ({
  // State variables
  ...initialState,

  // State setters
  resetPunchesByStaffSlice: () => set(initialState),
})

export default createPunchesByStaffSlice
